<template>
  <ag-card-container
    :title="$t('tokens.menu.main')"
    :search.sync="search"
    fluid
  >
    <template #left>
      <v-btn
        color="accent"
        small
        append
        to="ask"
        v-text="$t('tokens.menu.askTokenButton')"
      />
    </template>
    <template #extension>
      <v-tabs :slider-size="0" slider-color="accent" grow>
        <v-tab
          to="/tokens/history"
          exact
          @click="search = ''"
          v-text="$t('tokens.menu.history')"
        />
        <v-tab
          to="/tokens/demands"
          @click="search = ''"
          v-text="$t('tokens.menu.demands')"
        />
      </v-tabs>
    </template>
    <router-view :search="search" />
  </ag-card-container>
</template>

<script>
import AgCardContainer from 'src/components/common/AgCardContainer'

export default {
  name: 'TokensContainer',
  components: {
    AgCardContainer,
  },
  beforeRouteEnter (to, from, next) {
    return to.name === 'TokensMain'
      ? next({ name: 'TokensHistory' })
      : next()
  },
  beforeRouteUpdate (to, from, next) {
    return to.name === 'TokensMain'
      ? next({ name: 'TokensHistory' })
      : next()
  },
  data: () => ({
    search: '',
  }),
}
</script>

<style lang="scss" scoped>
.v-tab {
  &::before {
    opacity: 0.4 !important;
  }

  &:hover::before {
    opacity: 0.1 !important;
  }
}

.v-tab--active {
  &::before {
    opacity: 0.1 !important;
  }

  &:hover::before {
    opacity: 0.1 !important;
  }
}
</style>
